import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Checkbox from 'react-custom-checkbox';
import ImageGallery from 'react-image-gallery';
import { Scrollbar } from 'react-scrollbars-custom';
import Button from '../../common/Button';
import StringUtils from '../../common/utils/strings';
import check from '../../images/newDesign/check.svg';
import arrow from '../../images/newDesign/arrow.svg';
import defaultImage from '../../images/newDesign/buyMeRewardsGeneric.png';

import "react-image-gallery/styles/css/image-gallery.css";
import RewardDetailsPopUp from "./RewardDetailsPopUp/RewardDetailsPopUp";
import { useState } from "react";

export default function PrizesList({
                                       prizes = [],
                                       selectedPrizeId,
                                       setSelectedPrizeId,
                                       balance,
                                       collectPrize,
                                       canCollect,
                                       ltr,
                                       textOverrides = {},

}) {
    const {t} = useTranslation();
    const [state, showRewardDetailsPopUp] = useState({rewardDetailsPopUp: false});

    const getPrizeGalleryImages = (images = []) => {
        if (!images.length) return [{
            original: defaultImage
        }];

        return images.map(item => ({
            original: item.imageSrc
        }))
    }

    return (
        <div className={'rewards-block prizes'}>
            <div className="block-wrap">
                <h3 className='block-title'>{textOverrides.title || t('manager_rewards.prizes')}</h3>
                <Scrollbar
                    style={{ width: '100%', height: '350px' }}
                    trackYProps={{
                        renderer: props => {
                            const { elementRef, ...restProps } = props;
                            return <div {...restProps} ref={elementRef} className="scroll-track" />;
                        }
                    }}
                    thumbYProps={{
                        renderer: props => {
                            const { elementRef, ...restProps } = props;
                            return <div {...restProps} ref={elementRef} className="scroll-thumb" />;
                        }
                    }}
                    rtl={false}
                    noScrollX
                >
                    <ul className='list'>
                        {
                            prizes.map(item => (
                                <li
                                    key={item.campaignPrizeId}
                                >
                                    <div
                                        className={selectedPrizeId === item.campaignPrizeId ? 'selected visual' : 'visual'}
                                    >
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={props => (
                                                <Tooltip {...props}>
                                                    {item.coinValue > balance?.coinValue && t('manager_rewards.no_coins')}
                                                </Tooltip>
                                            )}
                                        >
                                            <div className='check'>
                                                <Checkbox
                                                    className={
                                                        item.coinValue > balance?.coinValue ? 'disabled' : selectedPrizeId === item.campaignPrizeId ? 'checked' : ''
                                                    }
                                                    name={item.campaignPrizeId}
                                                    checked={selectedPrizeId === item.campaignPrizeId}
                                                    icon={<img src={check} alt="check" />}
                                                    borderColor="#7D97FF"
                                                    borderWidth={1}
                                                    borderRadius={19}
                                                    style={{ overflow: "hidden" }}
                                                    size={19}
                                                    disabled={item.coinValue > balance?.coinValue}
                                                    onChange={(value) => setSelectedPrizeId(value ? item.campaignPrizeId : '')}
                                                />
                                            </div>
                                        </OverlayTrigger>

                                        <div className={'visual-wrap'}>
                                            <ImageGallery
                                                items={getPrizeGalleryImages(item.Images)}
                                                showFullscreenButton={false}
                                                showPlayButton={false}
                                                isRTL={!ltr}
                                                renderLeftNav={(onClick, disabled) => (
                                                    <button
                                                        type="button"
                                                        className="image-gallery-left-nav image-gallery-icon"
                                                        aria-label="Prev Slide"
                                                        disabled={disabled}
                                                        onClick={onClick}
                                                    >
                                                        <img src={arrow} alt="arrow" />
                                                    </button>
                                                )}
                                                renderRightNav={(onClick, disabled) => (
                                                    <button
                                                        type="button"
                                                        className="image-gallery-right-nav image-gallery-icon"
                                                        aria-label="Prev Slide"
                                                        disabled={disabled}
                                                        onClick={onClick}
                                                    >
                                                        <img src={arrow} alt="arrow" />
                                                    </button>
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className={'text'}>
                                        <p className={'name'}>
                                            {item.Details.name}
                                        </p>
                                        <p>
                                            <span className={'value'}>
                                                 {StringUtils.numberWithCommas(item.coinValue)}
                                            </span>
                                            <span className={'coins'}>{textOverrides.currency || t('manager_rewards.coins')}</span>
                                        </p>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </Scrollbar>

                {
                    prizes?.length > 0 && (
                        <div className={'collect'}>
                            <Button
                                type={'button'}
                                disabled={canCollect || !selectedPrizeId}
                                onClick={() => {showRewardDetailsPopUp({rewardDetailsPopUp: true})}}
                                rounded
                            >
                                {textOverrides.buttonText || t('manager_rewards.collect_prize')}
                            </Button>
                        </div>
                    )
                }
                <RewardDetailsPopUp
                    show={state.rewardDetailsPopUp}
                    collectPrize={collectPrize}
                    textOverrides={textOverrides}
                    setShow={show => showRewardDetailsPopUp(
                        (prev) => ({rewardDetailsPopUp: !prev.rewardDetailsPopUp})
                    )}
                />
            </div>
        </div>
    )
}
